import {
  addDoc,
  collection,
  doc,
  getDocs,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { checkParticipantsUserRole } from "../utils/checkParticipantsUserRole";
import firestore from ".";

export const getOrCreateConversation = async (
  creatorId,
  creatorName,
  creatorProfilePicture,
  creatorRole,
  participantId,
  participantName,
  participantProfilePicture,
  participantRole
) => {
  try {
    const conversationsRef = collection(firestore, "conversations");

    const q = query(
      conversationsRef,
      where("creatorId", "in", [creatorId, participantId]),
      where("participantId", "in", [creatorId, participantId])
    );

    const querySnapshot = await getDocs(q);

    let existingConversationId = null;
    let hasSameConversation = false;

    for (const docSnapshot of querySnapshot.docs) {
      const data = docSnapshot.data();
      const participants = data.participants;

      if (
        checkParticipantsUserRole(
          participants,
          creatorRole,
          creatorId,
          participantRole,
          participantId
        )
      ) {
        hasSameConversation = true;
        existingConversationId = docSnapshot.id;
        break;
      }
    }

    if (hasSameConversation) {
      return existingConversationId;
    }

    const newConversationRef = await addDoc(conversationsRef, {
      creatorId,
      creatorName,
      creatorProfilePicture,
      creatorRole,
      participantId,
      participantName,
      participantProfilePicture,
      participantRole,
      participants: [
        { userId: creatorId, role: creatorRole },
        { userId: participantId, role: participantRole },
      ],
      participantIds: [creatorId, participantId],
    });

    await updateDoc(doc(firestore, "conversations", newConversationRef.id), {
      id: newConversationRef.id,
    });

    return newConversationRef.id;
  } catch (error) {
    console.error("[Firestore] getOrCreateConversation error", error);
    return null;
  }
};
